export const companyCrmFlexGap = '16px';
